import QTimePicker from './src/QTimePicker';

QTimePicker.install = Vue => {
  Vue.component(QTimePicker.name, QTimePicker);
};

export default QTimePicker;
